/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Quick_Marked_ActionInputs */

const en_us2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just mark it done`)
};

const pt_br2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só marcar como feito`)
};

const es_419_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo marcar como hecho`)
};

const pt_pt2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só marcar como feito`)
};

const fr_fr2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste la marquer comme faite`)
};

const de_de2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur als erledigt markieren`)
};

const it_it2_workout_quick_marked_action = /** @type {(inputs: Workout_Quick_Marked_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segna solo come fatto`)
};

/**
* | output |
* | --- |
* | "Just mark it done" |
*
* @param {Workout_Quick_Marked_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_quick_marked_action = /** @type {((inputs?: Workout_Quick_Marked_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Quick_Marked_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_quick_marked_action(inputs)
	if (locale === "es-419") return es_419_workout_quick_marked_action(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_quick_marked_action(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_quick_marked_action(inputs)
	if (locale === "de-DE") return de_de2_workout_quick_marked_action(inputs)
	if (locale === "it-IT") return it_it2_workout_quick_marked_action(inputs)
	return en_us2_workout_quick_marked_action(inputs)
});
export { workout_quick_marked_action as "workout-quick.marked_action" }